export default {
    meta: {
        title: '线索列表',
        isShowNav: true,
    },
};
